import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// 引入Vuex store实例
import store from "./store";
// 引入自定义指令
import focusDirective from "./directives/focus";
// 引入全局CSS文件
import "./assets/css/global.css";

// 使用 createApp 创建 Vue 3 应用实例
const app = createApp(App);

// .use() 方法用于安装插件，这里我们安装 Vuex
app.use(store);
app.use(router);
// .directive() 方法用于注册全局自定义指令
app.directive("focus", focusDirective);

// 将应用挂载到 DOM 中
app.mount("#app");
